/**
 * Subheading Component
 * Dynamic subheading that displays beneath the logo and changes with navigation.
 * Wrap words in *asterisks* to highlight them in brand red.
 * e.g. "EXPLORE THE *FUTURE* OF SPACE"
 */

export function parseHighlights(text) {
  // Split on both *highlight* and |nowrap| markers
  const parts = text.split(/(\*[^*]+\*|\|[^|]+\|)/)
  return parts.map((part, i) => {
    if (/^\*[^*]+\*$/.test(part))
      return <span key={i} className="dsl-subheading-highlight">{part.slice(1, -1)}</span>
    if (/^\|[^|]+\|$/.test(part))
      return <span key={i} className="dsl-subheading-nowrap">{part.slice(1, -1)}</span>
    return part
  })
}

export function Subheading({ text = 'Explore the Future of Space', size, className = '', imageSrc = null, imageHeight = 48 }) {
  return (
    <div className={`dsl-subheading ${className}`} style={size ? { fontSize: size } : undefined}>
      {imageSrc
        ? <img src={imageSrc} alt="" className="dsl-subheading-img" />
        : parseHighlights(text)
      }
    </div>
  )
}

export default Subheading
